import React from 'react';
import PropType from 'prop-types';
import map from 'lodash/map';

import useShopify from '../hooks/shopify';
import shopifyConfigType from '../proptypes/shopify-config';
import ShopifyProduct from './ShopifyProduct';

const ShopifyProducts = ({
  config, collectionId, count, linkText,
}) => {
  const [products, collectionUrl] = useShopify(config, collectionId, count);

  if (collectionUrl === undefined || products === []) return null;
  return (
    <>
      <div className="shopify-products">
        <ul className="shopify-products__products">
          {map(products, (product, i) => (
            <li key={product.id}>
              <ShopifyProduct key={i} {...product} />
            </li>
          ))}
        </ul>
      </div>
      {linkText && (
        <div className="row justify-content-center mt-2 mb-2">
          <div className="col-8 col-lg-4 text-center">
            <a className="shopify-products__shop_now" href={collectionUrl}>{linkText}</a>
          </div>
        </div>
      )}
    </>
  );
};

ShopifyProducts.propTypes = {
  count: PropType.number,
  config: shopifyConfigType.isRequired,
  collectionId: PropType.string.isRequired,
  linkText: PropType.string,
};

ShopifyProducts.defaultProps = {
  count: 6,
  linkText: undefined,
};

export default ShopifyProducts;
